<script setup>
import { defineProps, ref } from 'vue'

const props = defineProps({
	version: Number,
})

const manualLink = ref(null)
</script>

<template>
	<div class="text-muted">
		<div v-if="props.version">{{ $t('standardVersion') }}: {{ props.version }}</div>

		<div>
			{{ $t('userManual') }}:
			<a ref="manualLink" href="app/usermanual" target="_blank" v-one-tooltip="$t('downloadUsermanual')">
				<i class="bi bi-book" style="font-size: 1.2rem; position: relative; top: 3px"></i>
			</a>
		</div>
	</div>
</template>
